import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomProductReviewsComponent} from './custom-product-reviews.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormErrorsModule, StarRatingModule} from '@spartacus/storefront';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';


@NgModule({
  declarations: [CustomProductReviewsComponent],
  exports: [CustomProductReviewsComponent],
  imports: [
    CommonModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    I18nModule,
    StarRatingModule,
    FormErrorsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductReviewsTabComponent: {
          component: CustomProductReviewsComponent,
        },
      },
    } as CmsConfig)
  ]
})
export class CustomProductReviewsModule {
}
